import type { Period } from "./period";

export type CalendarView = "month" | "agenda";

/**
 * Vue d'ouverture du calendrier. Un choix explicite (déjà enregistré) est
 * gardé ; sans choix, la liste « À venir » sur téléphone (la grille d'un mois
 * y est illisible) et la grille du mois sur ordinateur.
 */
export function initialCalendarView(
  saved: string | null,
  narrow: boolean,
): CalendarView {
  if (saved === "month" || saved === "agenda") return saved;
  return narrow ? "agenda" : "month";
}

/** Index (0-11) du mois à centrer dans la bande du sélecteur de période. */
export function monthToReveal(period: Period, now: Date): number {
  return period.kind === "month" ? period.month : now.getMonth();
}
